import { ApiRequest } from '../baseService'

const BaseRoute = 'app/smokeball-app'

const GetMatterDetail = (id, tenantId, companyPMSId = null) => {
  return ApiRequest.get(
    `${BaseRoute}/matters/${id}?tenantId=${tenantId ?? ''}&companyPMSId=${
      companyPMSId ?? ''
    }`
  )
}

const GetListMatters = (url, caseNo?) => {
  return ApiRequest.post(`${BaseRoute}/matters`, {
    method: 'Get',
    url: url,
    caseNo: caseNo,
  })
}

const GetListParticipant = (method, url, caseNo?) => {
  return ApiRequest.post(`${BaseRoute}/contacts`, {
    method: method,
    url: url,
    caseNo: caseNo,
  })
}

const GetMatterAccount = (matterId, companyPMSId = null) => {
  return ApiRequest.post(
    `${BaseRoute}/mattersAccount/${matterId}?companyPMSId=${companyPMSId ?? ''}`
  )
}

const GetTypeOfClaim = (claimTypeId: string, companyPMSId?: string) => {
  return ApiRequest.get(`${BaseRoute}/type-of-claim`, {
    params: {
      claimTypeId,
      companyPMSId: companyPMSId ?? null,
    },
  })
}

const GetRegisteredWebhooks = (companyPMSId?: string) => {
  return ApiRequest.get(`${BaseRoute}/register-webhooks`, {
    params: { companyPMSId: companyPMSId ?? null },
  })
}

const RegisterWebhooks = (companyPMSId?: string) => {
  return ApiRequest.post(`${BaseRoute}/register-webhooks`, null, {
    params: { companyPMSId: companyPMSId ?? null },
  })
}

const DeleteWebhook = (subscriptionId: string, companyPMSId?: string) => {
  return ApiRequest.delete(`${BaseRoute}/register-webhooks/${subscriptionId}`, {
    params: { companyPMSId: companyPMSId ?? null },
  })
}

const SearchMatterDocuments = payload => {
  return ApiRequest.post(`${BaseRoute}/matter-documents/search`, payload)
}

const ImportMatterDocuments = payload => {
  return ApiRequest.post(`${BaseRoute}/matter-documents/import`, payload)
}

const API = {
  GetMatterDetail,
  GetListMatters,
  GetListParticipant,
  GetMatterAccount,
  GetTypeOfClaim,
  GetRegisteredWebhooks,
  RegisterWebhooks,
  DeleteWebhook,
  SearchMatterDocuments,
  ImportMatterDocuments,
}
export default API
